<template>
  <div class="intelligent-booking-table" @click="() => jobNosDialog.isShow = false">
    <cargo-ag-grid
      class="intelligent-booking-table"
      :grid-params.sync="gridParams"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :show-side-bar="true"
      :config-module="configModule"
      :row-data="rowData"
      @gridReady="params=>{gridApi=params.api}"
    />
    <ul
      v-if="jobNosDialog.isShow"
      :style="{position: 'fixed',left: jobNosDialog.left + 'px',top: jobNosDialog.top + 'px', cursor: 'pointer' }"
    >
      <li
        v-for="(item, index) in jobNosDialog.intelligentDocumentItems"
        :key="index"
        :style="{ backgroundColor: item.isHovered ? '#a5ebff' : '#d7f5ff' }"
        @mouseover="changeColor(index, true)"
        @mouseout="changeColor(index, false)"
        @click.stop="jobNoClick(item.jobNo)"
      >
        <span style="color: #2280c4">{{ item.jobNo }}</span>
        <span style="margin-left: 10px">{{ ColumnUtils.jobBookingStateNew(item.bookingState) }}</span>
      </li>
    </ul>
    <el-dialog
      v-if="saveAndBookingDialog.visible"
      no="saveAndBookingDialog"
      :visible.sync="saveAndBookingDialog.visible"
      :title="$t('Message.WarmReminder')"
      width="630px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 40px 20px 40px">
        {{ $t('CargoMsg.Cargo_SelectJobNo') }}
        <cargo-ag-grid
          v-show="saveAndBookingDialog.jobList.length > 0"
          config-module="3300013"
          :grid-options="saveAndBookingDialog.gridOptions"
          :column-defs="saveAndBookingDialog.gridOptions.columnDefs"
          :row-data="saveAndBookingDialog.jobList || []"
          style="height: 200px"
          @gridReady="params=>{saveAndBookingDialog.gridOptions.gridApi=params.api}"
        />
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="closeDialog">{{ $t('Message.GotIt') }}</el-button>
        <el-button v-show="saveAndBookingDialog.jobList.length > 0" type="primary" @click="copyHandler">{{ $t('CargoMsg.Cargo_UpdateBusinessAgain') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadStatus from './UploadStatus'
import OperationRender from './OperationRender'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import {
  removeIntelligentDocument, queryIntelligentDocumentByFunc,
  queryIntelligentDocumentCwmiFunc, copyIntelligentDocumentFunc
} from '@/api/seaExport/intelligentBooking'
import {
  AE, AI,
  BS_ITEM_MAP,
  IDENTIFICATION_METHOD,
  IDENTIFICATION_TYPE_2,
  INTELLIGENT_DOCUMENT_SOURCE_10,
  INTELLIGENT_DOCUMENT_SOURCE_12,
  INTELLIGENT_DOCUMENT_SOURCE_13,
  INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE,
  INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE,
  INTELLIGENT_DOCUMENT_SOURCE_SE,
  SENDING_0,
  SENDING_1,
  SENDING_3, SENDING_4, SENDING_5,
  SENDING_7,
  SENDING_BY,
  SENDING_CWMI
} from '@/class/cargo/model/parameters/SystemConstants'
import { getStateByCode } from '@/class/cargo/model/parameters/CommonState'
import { CONSIGNMENT_NOTE_PLATFORMS } from '@/class/cargo/model/parameters/SystemConstants'
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { doJumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { checkBsItemOpened } from '@/api/booking/job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'IntelligentBookingTable',
  props: {
    rowData: {
      type: Array, default: () => []
    },
    tabType: {
      type: String,
      default: () => ''
    },
    configModule: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      IDENTIFICATION_TYPE_2,
      CONSIGNMENT_NOTE_PLATFORMS,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressContextMenu: true,
        onSelectionChanged: event => {
          const selectedRows = event.api.getSelectedRows()
          this.$emit('changeSelected', selectedRows)
        }
      },
      saveAndBookingDialog: {
        visible: false,
        uuid: '',
        source: 0,
        jobList: [], // 保存并订舱结果弹窗
        gridOptions: {
          gridApi: null,
          rowSelection: 'multiple',
          suppressCellSelection: true,
          columnDefs: [
            {
              headerName: '', width: 55, checkboxSelection: true,
              sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
              headerCheckboxSelection: true
            },
            { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobNo', width: 150,
              cellRendererFramework: 'agGridColumnEdit',
              custom: {
                tag: 'multi-router-and-print',
                attrs: params => {
                  const data = params.data
                  return {
                    useRoute: true,
                    usePrint: false,
                    jumpMethod: value => {
                      if (this.saveAndBookingDialog.source === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code ||
                        this.saveAndBookingDialog.source === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE.code) {
                        this.$router.push({ name: 'RemoteBooking', query: { jobNo: value }})
                      } else {
                        doJumpFinaceOrBusiness(this, value, data.lob, data.opOffice, true)
                      }
                      this.closeDialog()
                    }
                  }
                }
              }
            },
            { headerName: this.$t('CargoMsg.Cargo_Status'), field: 'bookingState', minWidth: 50, colId: 'bookingState',
              cellRenderer: (params) => {
                return ColumnUtils.jobBookingStateNew(params.value)
              }
            }
          ]
        }
      },
      storageURL: '',
      gridApi: null,
      jobNosDialog: {
        isShow: false,
        intelligentDocumentItems: [],
        left: 0,
        top: 0,
        identificationType: SENDING_0.code, // 默认海出
        source: INTELLIGENT_DOCUMENT_SOURCE_SE.code
      },
      ColumnUtils
    }
  },
  computed: {
    columnDefs() {
      // const { storageURL } = this
      const columnDefs = [
        {
          colId: 'checkboxSelection',
          field: 'checkboxSelection',
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true,
          initialHide: this.tabType !== 'tabPending',
          suppressColumnsToolPanel: this.tabType !== 'tabPending'
        },
        { headerName: this.$t('SeaExport.SerialNo'), colId: 'fileNo', field: 'fileNo', width: 100 },
        { headerName: this.$t('FileHistory.fileName'), colId: 'fileName', field: 'fileName', cellRenderer: (params) => {
          if (params.data.fileId) {
            const url = `${URL.common.findByFileId}/${params.data.fileId}?sessionId=${this.$store.getters.token}`
            return `<a href="${url}" target="_blank" style="color:#1890ff">${params.value}</a>`
          } else {
            return params.value
          }
        }, width: 380
        },
        {
          headerName: this.$t('FileHistory.fileSize'), colId: 'fileSize', field: 'fileSize',
          cellRenderer: (params) => {
            return ColumnUtils.fileSizeLabelFun(params.value)
          }, width: 120
        },
        { headerName: this.$t('Partners.UploadTime'), colId: 'dateCreated', field: 'dateCreated' },
        {
          headerName: this.$t('SeaExport.ResolutionCompletionTime'),
          colId: 'analysisCompleteDate',
          field: 'analysisCompleteDate'
        },
        { headerName: this.$t('FileHistory.jobType'), colId: 'fileType', field: 'fileType', width: 120 },
        {
          headerName: this.$t('SeaExport.Source'), colId: 'source', field: 'source', width: 120, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.intelligentDocumentSourceLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_IdentificationType'), colId: 'identificationType', field: 'identificationType', width: 120,
          cellRenderer: (params) => {
            const state = getStateByCode(IDENTIFICATION_TYPE_2, params.value)
            if (!state) return ''
            return this.$store.getters.isZh ? state.chineseName : state.englishName
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_IdentificationChannel'), colId: 'identificationChannel',
          field: 'identificationChannel', width: 120,
          cellRenderer: (params) => {
            const state = getStateByCode(CONSIGNMENT_NOTE_PLATFORMS, params.value)
            if (!state) return ''
            return this.$store.getters.isZh ? state.chineseName : state.englishName
          }
        },
        // {
        //   headerName: this.$t('SeaExport.UploadProgress'), colId: 'status', field: 'status',
        //   cellRendererFramework: UploadStatus, width: 120,
        //   filterParams: {},
        //   filterValueGetter: (params) => {
        //     let str = ''
        //     switch (params.data.status) {
        //       case 1:
        //         str = this.$t('SeaExport.ParsingFailed')
        //         break
        //       case 2:
        //         str = this.$t('SeaExport.ParsingComplete')
        //         break
        //       case 3:
        //         str = this.$t('SeaExport.OrderGenerated')
        //         break
        //       case 4:
        //         str = this.$t('Partners.deleted')
        //         break
        //       default:
        //         str = this.$t('SeaExport.UploadCompletedParsing')
        //         break
        //     }
        //     return str
        //   }
        // },
        {
          headerName: this.$t('FileHistory.operation'), colId: 'operations', field: 'operations',
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('SeaExport.ViewParsingResults'),
                type: 'primary',
                onClick: (params) => {
                  this.$emit('showDetails', { from: this.tabType, params })
                },
                visible: (params) => params.status === 2 || params.status === 3
              }, {
                title: this.$t('SeaExport.ViewOrder'),
                type: 'primary',
                onClick: (params) => {
                  const jobNo = params.jobNo || params.intelligentDocumentItems[0].jobNo
                  if (params.identificationType === 1) {
                    this.$router.push({ name: 'SiBooking', query: { jobNo: params.jobNo }})
                  } else if (params.identificationType === SENDING_3.code) {
                    if (params.lob === 'AE') {
                      this.$router.push({ name: 'AeBooking', params: { jobUuid: params.jobUuid, activeTabName: 'tabCustomsInfo' }})
                    } else {
                      this.$router.push({ name: 'SeaBooking', params: { jobUuid: params.jobUuid, activeTabName: 'tabCustomsInfo' }})
                    }
                  } else if (params.identificationType === SENDING_7.code) {
                    this.$router.push({ name: 'AeBooking', query: { jobNo: jobNo, activeTabName: '' }})
                    if (params.lob === 'AE') {
                      this.$router.push({ name: 'AeBooking', params: { jobUuid: params.jobUuid, activeTabName: 'tabTradeDetail' }})
                    } else {
                      this.$router.push({ name: 'SeaBooking', params: { jobUuid: params.jobUuid, activeTabName: 'tabTradeDetail' }})
                    }
                  } else {
                    if (Number(params.source) === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code || Number(params.source) === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE.code) {
                      this.$router.push({ name: 'RemoteBooking', query: { jobNo: jobNo }})
                    } else if (params.identificationType === SENDING_4.code) {
                      this.$router.push({ name: 'AeBooking', query: { jobNo: jobNo, activeTabName: '' }})
                    } else if (params.identificationType === SENDING_5.code) {
                      this.$router.push({ name: 'AiBooking', params: { jobNo: jobNo, activeTabName: '' }})
                    } else {
                      this.$router.push({ name: 'SeaBooking', query: { jobNo: jobNo, activeTabName: '' }})
                    }
                  }
                },
                visible: (params) => params.status === 3 && ((!!params.jobNo && params.identificationType !== SENDING_3.code) || (params.intelligentDocumentItems && params.intelligentDocumentItems.length === 1))
              }, {
                title: this.$t('SeaExport.ViewOrder'),
                type: 'primary',
                showDropdownTriangle: true,
                onClick: (params, event) => {
                  this.jobNosDialog.isShow = true
                  this.jobNosDialog.left = event.clientX
                  this.jobNosDialog.top = event.clientY
                  this.jobNosDialog.intelligentDocumentItems = params.intelligentDocumentItems
                  this.jobNosDialog.identificationType = params.identificationType
                  this.jobNosDialog.source = Number(params.source)
                  event.stopPropagation()
                },
                // 只有海出托书才会有数据，海进提单不会有该数据
                visible: (params) => params.status === 3 && params.intelligentDocumentItems && params.intelligentDocumentItems.length > 1
              }, {
                title: this.$t('CargoMsg.Cargo_ModifyBusiness'),
                type: 'primary',
                onClick: (params, event) => {
                  if (params.intelligentDocumentItems && params.intelligentDocumentItems.length > 1) {
                    this.saveAndBookingDialog.visible = true
                    this.saveAndBookingDialog.source = Number(params.source)
                    this.saveAndBookingDialog.uuid = params.uuid
                    this.saveAndBookingDialog.jobList = params.intelligentDocumentItems
                  } else {
                    this.oneCopyHandler([{ page: 0 }], params.uuid, params.identificationType)
                  }
                  event.stopPropagation()
                },
                // 只有海出托书才会有数据，海进提单不会有该数据
                visible: (params) => params.status === 3 && (params.identificationType !== SENDING_3.code) && params.identificationChannel === SENDING_CWMI.code && params.intelligentDocumentItems
              }, {
                title: this.$t('SeaExport.Query'),
                type: 'primary',
                onClick: (params) => this.handleQuery(params.clientRefId, params.identificationChannel),
                visible: (params) => params.status === 0 && (params.identificationChannel === SENDING_BY.code || params.identificationChannel === SENDING_CWMI.code)
              }, {
                title: this.$t('FileHistory.Delete'),
                type: 'danger',
                onClick: (params) => this.handleDelete(params.uuid),
                visible: (params) => params.status === 0 || params.status === 1 || params.status === 2
              }
            ]
          }
        }
      ]
      if (this.tabType === 'tabFinished') {
        // 【业务进度】
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_JobProcess'), colId: 'jobProcess',
          field: 'jobProcess', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.multiJobBookingState(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.multiJobBookingState(params.data)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'), colId: 'jobNos',
          field: 'jobNos', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.multiJobNo(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.multiJobNo(params.data)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        })
      } else {
        // 【上传进度】
        columnDefs.push({
          headerName: this.$t('SeaExport.UploadProgress'), colId: 'status', field: 'status',
          cellRendererFramework: UploadStatus, width: 120,
          filterParams: {},
          filterValueGetter: (params) => {
            let str = ''
            switch (params.data.status) {
              case 1:
                str = this.$t('SeaExport.ParsingFailed')
                break
              case 2:
                str = this.$t('SeaExport.ParsingComplete')
                break
              case 3:
                str = this.$t('SeaExport.OrderGenerated')
                break
              case 4:
                str = this.$t('Partners.deleted')
                break
              default:
                str = this.$t('SeaExport.UploadCompletedParsing')
                break
            }
            return str
          }
        })
      }
      if (this.tabType === 'tabPending') {
        // 【识别方式】
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_IdentificationMethod'), colId: 'identificationMethod',
          field: 'identificationMethod', width: 120,
          cellRenderer: (params) => {
            const state = getStateByCode(IDENTIFICATION_METHOD, params.value)
            if (!state) return ''
            return this.$store.getters.isZh ? state.chineseName : state.englishName
          }
        })
      }
      return columnDefs
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
    },
    handleDelete(uuid) {
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteBookingNote', [1]), this.$t('SeaExport.Tips'), {}).then(() => {
        removeIntelligentDocument(uuid).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.$emit('refresh')
        })
      })
    },
    handleQuery(uuid, identificationChannel) {
      if (!uuid) {
        return
      }
      if (identificationChannel === SENDING_BY.code) {
        queryIntelligentDocumentByFunc(uuid).then(res => {
          if (res.data === 'ok') {
            this.$emit('refresh')
          } else if (res.data === 'doing') {
            this.$message.warning(this.$t('CargoMsg.Cargo_InAnalysis'))
          }
        })
      } else if (identificationChannel === SENDING_CWMI.code) {
        queryIntelligentDocumentCwmiFunc(uuid).then(res => {
          if (res.data === 'ok') {
            this.$emit('refresh')
          } else if (res.data === 'doing') {
            this.$message.warning(this.$t('CargoMsg.Cargo_InAnalysis'))
          }
        })
      }
    },
    jobNoClick(jobNo) {
      if (this.jobNosDialog.identificationType === SENDING_1.code) {
        this.$router.push({ name: 'SiBooking', query: { jobNo: jobNo }})
      } else if (this.jobNosDialog.identificationType === SENDING_3.code) {
        if (this.jobNosDialog.source === INTELLIGENT_DOCUMENT_SOURCE_10.code) {
          this.$router.push({ name: 'AeBooking', query: { jobNo: jobNo, activeTabName: 'tabCustomsInfo' }})
        } else {
          this.$router.push({ name: 'SeaBooking', query: { jobNo: jobNo, activeTabName: 'tabCustomsInfo' }})
        }
      } else {
        if (this.jobNosDialog.source === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code || this.jobNosDialog.source === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE.code) {
          this.$router.push({ name: 'RemoteBooking', query: { jobNo: jobNo }})
        } else if (this.jobNosDialog.identificationType === SENDING_4.code) {
          this.$router.push({ name: 'AeBooking', query: { jobNo: jobNo, activeTabName: '' }})
        } else if (this.jobNosDialog.identificationType === SENDING_5.code) {
          this.$router.push({ name: 'AiBooking', params: { jobNo: jobNo, activeTabName: '' }})
        } else {
          this.$router.push({ name: 'SeaBooking', query: { jobNo: jobNo, activeTabName: '' }})
        }
      }
      this.jobNosDialog.isShow = false
    },
    closeDialog() {
      this.saveAndBookingDialog.visible = false
    },
    async copyHandler() {
      await this.oneCopyHandler(this.saveAndBookingDialog.gridOptions.gridApi.getSelectedRows(), this.saveAndBookingDialog.uuid)
    },
    async oneCopyHandler(selects, uuid, identificationType) {
      if (!selects || selects.length === 0 || selects.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectBusinessTip'))
        return
      }
      // 查询计费系统是否开通托书
      const loading = getLoading4Cxt(this)
      let code = SystemConstants.TYPE_Shipping
      if (identificationType) {
        code = BS_ITEM_MAP.get(identificationType)
      }
      await checkBsItemOpened(code).then(res => {
        if (!res.data || res.data === -1) {
          // 计费未开通
          this.$message.warning(this.$t('CargoMsg.Cargo_UnopenedService'))
          return
        } else if (res.data === -2) {
          // 计费开通，余额不足
          this.$message.warning(this.$t('CargoMsg.Cargo_RemainingAmountNotEnough2'))
          return
        }
        this.doCopyHandler(selects[0], uuid)
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    doCopyHandler(data, uuid) {
      const loading = getLoading4Cxt(this)
      let index = 0
      if (data.page) {
        index = Number(data.page)
      }
      copyIntelligentDocumentFunc({ uuid: uuid, index: index }).then(res => {
        this.saveAndBookingDialog.visible = false
        const e = {
          from: 'tabPending',
          params: res.data,
          source: this.saveAndBookingDialog.source
        }
        this.$emit('showDetails', e)
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    changeColor(index, isHovered) {
      this.jobNosDialog.intelligentDocumentItems[index].isHovered = isHovered
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss">
.intelligent-booking-table {
  height: 100%;
  ul {
    list-style-type: none;
    padding-left: 0;
    li {
      padding: 10px;
    }
  }
}

</style>
